<template>
	<div>
		<b>Identificação</b>
		<div class="well well-sm">
			<div class="row">
				<div class="col-sm-6">
					Tipo de empresa
					<select
						:disabled="disabled || this.data.tipo_de_cliente == 7"
						v-model="data.tipo_empresa"
						class="form-control"
					>
						<option value="sede">SEDE</option>
						<option value="filial">FILIAL</option>
						<option value="posto">POSTO</option>
					</select>
				</div>
				<div class="col-sm-6">
					Marcadores
					<tags
						v-model="data.tags"
						:disabled="disabled || this.data.tipo_de_cliente == 7"
					/>
				</div>
				<div class="col-sm-6">
					Tipo de Cliente
					<select v-model="data.tipo_de_cliente" class="form-control">
						<option
							v-for="(customer, index) in typeOfCustomers"
							:key="index"
							:value="customer.cod"
						>
							{{ customer.title }}
						</option>
					</select>
				</div>
				<div class="clearfix"></div>
				<div class="col-sm-6">
					CNPJ
					<div :class="{ 'has-error': !valid }" class="input-group">
						<input
							:disabled="
								disabled || this.data.tipo_de_cliente == 7
							"
							type="text"
							class="form-control"
							v-model="data.cnpj"
							placeholder="__.___.___/____-__"
							v-mask="'##.###.###/####-##'"
						/>
						<div class="input-group-btn">
							<button
								title="Pesquisar no Web Service da receita"
								:disabled="
									disabled || this.data.tipo_de_cliente == 7
								"
								class="btn"
								:class="{
									'btn-primary': valid,
									'btn-danger': !valid,
								}"
								@click="search()"
							>
								<i v-if="!active" class="fa fa-search"></i>
								<i v-else class="fa fa-spin fa-spinner"></i>
							</button>
						</div>
					</div>
				</div>
				<div class="col-sm-6">
					Razão Social
					<input
						:disabled="disabled"
						type="text"
						v-model="data.razao_social"
						class="form-control"
					/>
				</div>
				<div
					class="col-sm-3"
					v-if="data.tipo_empresa != 'sede' && data.tipo_empresa != 7"
				>
					CNPJ da matriz
					<input
						:disabled="disabled || this.data.tipo_de_cliente == 7"
						type="text"
						class="form-control"
						v-model="data.cnpj_matriz"
						placeholder="__.___.___/____-__"
						v-mask="'##.###.###/####-##'"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import WBS from 'js/http';
	import toastr from 'toastr';
	import tags from 'tags';
	import { reset_representante } from '../reset.js';
	import { clone } from 'lodash';

	export default {
		name: 'ClientIdentification',
		components: { tags },
		props: ['dIn', 'disabled'],
		data() {
			return {
				active: false,
				typeOfCustomers: [],
				valid: true,
			};
		},
		watch: {
			// 'data.cnpj': function(val){
			//   this.active = true
			//   if( val.length == 18){
			//     WBS.send('private-save-customers:searchExixts', val, resp => {
			//       this.active = false
			//       if(resp.status == "success"){
			//         this.valid = true
			//       }else{
			//         toastr.error(resp.msgs[0])
			//         this.valid = false
			//       }
			//     })
			//   }
			// }
		},
		methods: {
			is_valid() {
				return this.valid;
			},
			handleChangeData() {
				const cpf = this.data.prevencaoCovid;
				console.log(cpf);
			},

			search(checkInReceita = true) {
				if (this.active == false) {
					this.active = true;

					let sData = {
						cnpj: this.data.cnpj,
						isNew: this.data.cod == undefined ? 1 : 0,
						checkInReceita: checkInReceita,
					};

					// console.log(sData)

					WBS.send('public-custom-scnpj', sData, (resp) => {
						// console.log(resp)
						this.active = false;
						if (resp.status == 'success') {
							this.valid = true;

							this.data.prevencaoCovid = resp.data.prevencaoCovid;
							this.data.razao_social = resp.data.nome;

							this.data.endereco.logradouro =
								resp.data.logradouro;
							this.data.endereco.complemanto =
								resp.data.complemento;
							this.data.endereco.bairro = resp.data.bairro;
							this.data.endereco.localidade = resp.data.municipio;
							this.data.endereco.cep = resp.data.cep;
							this.data.endereco.uf = resp.data.uf;
							this.data.endereco.numero = resp.data.numero;

							this.data.documentos.data_doc = resp.data.abertura
								.split('/')
								.reverse()
								.join('-');
							// this.data.contato = resp.data.email
							this.data.telefones.nextel = resp.data.telefone;

							this.data.documentos.cnae =
								resp.data.atividade_principal[0].code;

							this.data.representates = [];
							resp.data.qsa.forEach((item) => {
								let newRp = clone(reset_representante);
								newRp.nome = item.nome;
								newRp.qual = item.qual;
								this.data.representates.push(newRp);
							});
						} else {
							toastr.error(resp.msgs[0]);
							if (
								resp.msgs[0] ==
								'CNPJ rejeitado pela Receita Federal'
							)
								this.valid = true;
							else this.valid = false;
							console.log(resp);
						}
					});
				}
			},
		},
		computed: {
			data() {
				return this.dIn;
			},
		},
		mounted() {
			WBS.send('protected-read-TypeOfCustomers', (resp) => {
				this.typeOfCustomers = resp.data;
			});
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/customers/components/identification.vue